import { UseSendTransactionArgs } from "wagmi/dist/declarations/src/hooks/transactions/useSendTransaction";
import { getReq, postReq } from "../ApiHelpers";

export type CreateRequestTemplateParams = {
  tokenId: number | string;
  fields: any[];
  isEnabled: boolean;
};

export const createRequestTemplate = ({
  tokenId,
  fields,
  isEnabled,
}: CreateRequestTemplateParams) => {
  return postReq(
    `/token/${tokenId}/templates`,
    { fields, isEnabled },
    undefined,
    true,
  );
};

export type GetRequestTemplateParams = {
  tokenId: number | string;
  limit?: number;
  offset?: number;
};

export const getRequestTemplates = ({
  tokenId,
  limit = 10,
  offset = 0,
}: GetRequestTemplateParams) => {
  return getReq(
    `/token/${tokenId}/templates?limit=${limit}&offset=${offset}`,
    undefined,
    false,
  );
};

export type CreateRequestParams = {
  username: string;
  tokenId: number;
  templateId: string;
  templateAnswers: any[];
  requesterWalletAddress: string;
  signature: string;
  fields: any[];
};

export const createRequest = ({
  username,
  tokenId,
  templateId,
  templateAnswers,
  requesterWalletAddress,
  signature,
}: CreateRequestParams) => {
  return postReq(
    `/identities/${username}/requests`,
    {
      templateId,
      templateAnswers,
      tokenId,
      requesterWalletAddress,
      signature,
    },
    undefined,
    true,
  );
};

export type RequestStatus = "pending" | "approved" | "rejected" | "cancelled";

export type GetRequestsForTokenParams = {
  tokenId: number;
  limit?: number;
  offset?: number;
  statusType?: RequestStatus;
};

export const getRequestsForToken = ({
  tokenId,
  limit = 50,
  offset = 0,
  statusType = "pending",
}: GetRequestsForTokenParams) => {
  const url = `/token/${tokenId}/requests?limit=${limit}&offset=${offset}&statusType=${statusType}`;
  return getReq(url, undefined, true);
};

export type GetRequestsForIdentityParams = {
  username: string;
  limit?: number;
  offset?: number;
  statusType?: RequestStatus;
  tokenId?: number;
};

export const getRequestsForIdentity = ({
  username,
  limit = 50,
  offset = 0,
  statusType = "pending",
  tokenId,
}: GetRequestsForIdentityParams) => {
  let url = `/identities/${username}/requests?limit=${limit}&offset=${offset}&statusType=${statusType}`;
  if (tokenId) {
    url = url + `&tokenId=${tokenId}`;
  }
  return getReq(url, undefined, true);
};

export type RequestAction = {
  statusType: RequestStatus;
  id: string;
  comments?: string;
};

export type ModifyRequestsParams = {
  tokenId: number;
  requests: RequestAction[];
  updatedByAddress: string;
  signature: string;
};

export const modifyRequests = ({
  tokenId,
  requests,
  updatedByAddress,
  signature,
}: ModifyRequestsParams) => {
  return postReq(
    `token/${tokenId}/requests`,
    {
      requests,
      updatedByAddress,
      signature,
    },
    undefined,
    true,
  );
};

export const getCommunityTokensWithRequests = ({
  communityUniqId,
  statusType = "pending",
}: {
  communityUniqId: string;
  statusType: string;
}) => {
  return getReq(
    `/communities/${communityUniqId}/requests?statusType=${statusType}`,
    undefined,
    true,
  );
};
